module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('y-shelf', {
    attrs: {
      "title": "安全中心"
    }
  }, [_c('span', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "deposit-main"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa0c9dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/children/desOrder.vue
// module id = 644
// module chunks = 0